export const LEAD = 1
export const CUSTOMER = 2
export const LEAD_PN = 3
export const PN = 4